import { render, staticRenderFns } from "./staff-modal.vue?vue&type=template&id=037b2458&"
import script from "./staff-modal.vue?vue&type=script&lang=js&"
export * from "./staff-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports